function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUobLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 542,
    height: 164,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M194.152 757.535h10.004c10.836 0 16.301 7.32 16.301 14.449 0 7.223-3.519 14.817-15.746 14.817-7.781 0-10.559-2.5-10.559-9.539zm-7.683 22.41c0 5.84-1.485 7.598-9.074 7.598h-2.133v1.758h33.894c14.914 0 20.008-10.278 20.008-17.594 0-7.223-5.094-12.875-13.797-15.469v-.187c6.203-1.11 10.555-6.016 10.555-11.293 0-4.449-1.852-7.602-5.649-10.281-3.335-2.411-10.464-3.618-18.617-3.618-1.761 0-8.797.094-13.894.282-2.684.093-9.074.464-11.668.55v1.762h3.242c6.48 0 7.133 2.777 7.133 8.059zm7.683-47.047c2.317-.093 6.118-.277 8.153-.277 11.39 0 15.281 5.926 15.281 12.41 0 7.227-4.445 10.742-13.336 10.742h-10.098z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M254.543 763.371c-2.133 0-3.523.09-5.742-.183v-30.383c1.664-.184 2.871-.184 4.629-.184 14.273 0 18.156 6.668 18.156 15.281 0 11.114-6.754 15.469-17.043 15.469m68.437-29.918v-1.762h-22.507v1.762c5.183.277 6.949 1.664 6.949 6.668v39.457c0 6.02-1.149 7.586-6.445 7.934-7.067-.371-10.067-3.145-15.133-8.207l-7.313-7.321c-4.347-4.351-7.125-6.949-10.554-9.632 7.593-2.223 12.312-8.059 12.312-15.004 0-9.45-7.684-16.489-24.82-16.489-6.024 0-7.875.094-11.672.282-3.797.183-9.449.55-11.668.55v1.762h2.035c5.371 0 6.949 1.664 6.949 7.41v38.993c0 6.207-1.949 7.687-7.41 7.687h-1.574v1.758h26.215v-1.758h-2.133c-5.191 0-7.41-1.391-7.41-6.945v-15.657c1.48.094 2.683.192 4.722.192 2.504 0 3.985-.098 6.301-.192 2.227 1.485 5.473 4.168 9.543 8.247l6.113 6.117c8.004 8.011 11.422 10.543 26.504 9.996h20.996v-1.758c-6.39 0-7.871-1.852-7.871-7.316v-39.27c0-6.203 2.036-7.504 7.871-7.504",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M329.277 775.227c1.95 8.242 8.426 13.058 15.653 13.058 6.207 0 12.781-3.613 12.781-10.929 0-13.34-29.731-17.411-29.731-33.618 0-7.691 7.04-13.433 16.489-13.433 7.773 0 9.351 2.316 12.594 2.316.742 0 1.109-.187 1.667-.93h1.481l1.574 11.766h-1.574c-2.594-6.668-8.52-10.926-14.91-10.926-6.113 0-10.375 3.516-10.375 8.703 0 13.153 29.73 16.676 29.73 33.711 0 9.078-8.058 15.84-18.894 15.84-5.094 0-11.574-2.5-12.871-2.5-.832 0-1.485.461-1.856 1.016h-1.57l-1.945-14.074z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M400.316 780.785c0 5 1.664 6.758 7.313 6.758h3.434v1.758h-29.18v-1.758h3.43c5.648 0 7.312-1.758 7.312-6.758v-45.754h-16.113c-3.703 0-5.371 2.125-6.766 10.278h-1.664l1.481-15.004h1.757c.102.554.469.929 1.024 1.109.554.191 1.207.277 1.851.277h44.547c1.301 0 2.692-.277 2.875-1.386h1.758l1.484 15.004h-1.671c-1.383-8.153-3.051-10.278-6.754-10.278h-16.118z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M492.672 758.926c0-16.672-15.004-28.621-32.508-28.621-19.726 0-33.902 13.058-33.902 31.488 0 17.324 15.289 28.992 33.437 28.992 17.969 0 32.973-13.152 32.973-31.859m-8.707 3.054c0 13.149-7.223 26.485-22.32 26.485-14.915 0-26.672-12.219-26.672-29.539 0-11.117 6.476-26.305 22.781-26.305 15.281 0 26.211 12.137 26.211 29.359",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M535.703 789.301h-41.398v-1.758h3.05c4.262 0 5.836-1.391 5.836-6.113v-41.032c0-4.906-1.48-6.945-7.312-6.945h-1.297v-1.762h27.32v1.762h-3.429c-6.016 0-7.594.649-7.594 6.391v42.695c0 2.5 1.019 3.43 3.707 3.43h13.609c5.465 0 7.129-2.129 12.973-10.188h1.664z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bf2f38",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf2f38",
      fillOpacity: 1
    },
    d: "M103.047 705.219c-.067-5.391-1.899-16.41-14.793-22.664 13.094 4.16 19.394 15.226 20.035 23.48 13.75 2.742 25.953 9.211 45.766 2.379l.066-.043s-26.07.238-36.973-7.648c5.633.211 12.114-1.063 14.239-4.25 2.261-3.395 2.496-6.903 8.074-7.082 3.133-.102 13.758.691 14.871-14.911-3.398 5.739-7.082 8.11-12.641 6.692-3.55-.902-10.031-3.621-14.664 1.914-3.824 4.566-7.929 6.941-14.48 6.234 2.621-3.543 41.68-54.258 41.68-54.258s-50.039 40.161-52.801 42.5c-.531-7.332 1.664-10.023 4.601-13.246 2.407-2.636 6.586-6.207 3.258-13.742-2.687-6.09-2.336-9.773 4.996-15.617-5.843.426-14.762 4.355-13.707 15.086.641 6.48-3.953 7.043-5.629 7.969-4.355 2.41-4.922 9.422-5.066 14.875-.492-1.774-6.832-29.024-9.063-37.84v73.324h.168c8.493-3.344 15.555-3.855 22.063-3.152",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M227.512 665.637v1.304c-4.602.071-6.25 1.922-6.25 6.321v18.543c0 8.515-5.426 17.648-20.328 17.648-13.118 0-19.848-7.484-19.848-17.305v-20.054c0-4.395-1.238-5.082-5.906-5.153v-1.304h17.648v1.304h-.617c-3.777 0-5.426 1.032-5.426 5.016v19.09c0 9.273 5.426 14.836 15.66 14.836 7.758 0 15.66-3.227 15.66-14.903v-16.003c0-6.594-1.031-7.758-6.734-8.036v-1.304z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M236.539 702.379c0 3.777.891 4.672 4.598 4.672v1.304h-13.801v-1.304c3.019 0 4.602-1.649 4.602-4.328v-14.422c0-2.539-.278-3.024-2.063-3.367l-2.336-.477v-1.102l7.899-2.882h1.101v5.355c4.598-2.883 8.445-5.426 11.813-5.426 4.668 0 7.347 3.434 7.347 10.301 0 9.137-.48 10.922-.551 13.602-.066 1.851 1.032 2.746 3.848 2.746h1.512v1.304h-14.77v-1.304c1.992-.071 3.16-.551 3.914-1.305 1.309-1.305 1.446-6.32 1.446-15.453 0-5.496-2.68-7.211-5.426-7.211-2.199 0-5.563 1.922-9.133 4.395z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M270.824 664.605c1.649 0 3.024 1.168 3.024 2.614 0 1.441-1.375 2.609-3.024 2.609-1.648 0-2.953-1.168-2.953-2.609 0-1.446 1.305-2.614 2.953-2.614m2.817 38.532c0 2.402 1.304 3.914 4.945 3.914v1.304H263.34v-1.304c4.187 0 5.699-1.375 5.699-5.016v-13.801c0-2.679-.344-3.023-2.129-3.367l-3.226-.617v-1.102l8.925-3.089h1.032z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "m294.27 708.973-9.957-22.801c-1.036-2.402-1.926-3.227-3.024-3.434l-2.133-.343v-1.235h14.016v1.235c-4.192.136-5.496.687-3.852 3.914l7.285 17.101 7.004-15.863c1.239-2.817.618-4.809-4.394-5.152v-1.235h11.945v1.235c-2.605.48-4.121 1.992-5.422 5.015l-9.476 21.563z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M336.781 690.91v-1.578c-2.261-2.27-2.058-8.93-11.332-8.93-8.379 0-13.254 7.418-13.254 14.7 0 7.964 5.219 14.078 11.95 14.078 5.015 0 9.339-3.434 12.226-7.075l-.758-.824c-2.605 3.09-5.285 4.465-8.718 4.465-5.426 0-10.442-4.808-10.442-11.949 0-.895.141-1.856.277-2.887zm-19.847-1.785c1.582-6.387 5.015-7.418 7.285-7.418 3.293 0 6.039 2.953 6.797 7.418z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M350.027 703.344c0 2.812 1.032 3.707 4.461 3.707h2.614v1.304H340.82v-1.304c3.504-.071 4.606-1.512 4.606-5.153v-15.863l-4.606-1.648v-1.168l7.832-2.746h1.375v7.277h.137c3.434-5.629 4.258-6.934 6.524-6.934.828 0 1.031.067 2.335.618.688.273 1.922.546 3.575 1.031l-1.653 4.117a12.6 12.6 0 0 1-3.636-1.098c-.754-.343-1.579-.687-2.407-.687-1.238 0-1.992.824-2.675 1.785-.895 1.238-1.653 2.406-2.2 3.438z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M367.34 701.418c.82 4.121 3.43 6.457 6.523 6.457 2.742 0 4.875-2.062 4.875-4.531 0-1.446-.343-2.336-2.199-4.192-4.879-4.875-10.301-5.355-10.301-11.058 0-4.532 3.575-7.692 8.789-7.692 1.856 0 3.782.414 5.496 1.098l.137 6.25h-1.168c-.48-3.5-2.75-5.699-5.496-5.699-2.266 0-4.183 1.578-4.183 3.847 0 6.043 12.769 7.075 12.769 15.454 0 4.461-3.707 7.828-8.516 7.828-1.3 0-2.265-.207-3.019-.481-.758-.207-1.305-.414-1.856-.414-.414 0-.824.278-1.168.824h-1.031l-.754-7.691z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M394.273 664.605c1.653 0 3.028 1.168 3.028 2.614 0 1.441-1.375 2.609-3.028 2.609-1.64 0-2.949-1.168-2.949-2.609 0-1.446 1.309-2.614 2.949-2.614m2.821 38.532c0 2.402 1.304 3.914 4.941 3.914v1.304h-15.246v-1.304c4.191 0 5.699-1.375 5.699-5.016v-13.801c0-2.679-.34-3.023-2.129-3.367l-3.222-.617v-1.102l8.926-3.089h1.031z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "m421.609 681.16-1.097 3.02h-8.723v16.004c0 4.324 3.094 5.769 4.531 5.769 1.512 0 2.887-1.168 4.192-3.437l1.097 1.031c-1.648 3.57-4.328 5.633-7.488 5.633-4.051 0-6.933-3.367-6.933-7.965V684.18h-3.161v-1.098c2.68-1.305 5.016-4.465 6.594-8.723h1.168v6.801z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M448.777 688.781c2.059-5.219.754-6.25-3.297-6.386v-1.235h11.399v1.235c-2.816.343-4.395 2.265-5.695 5.492l-11.676 29.121c-2.067 5.082-3.645 7.347-6.043 7.347-1.652 0-2.82-1.027-2.82-2.402 0-2.816 3.984-2.129 5.703-3.844.754-.757 1.785-2.543 2.332-3.918l2.058-5.148-10.64-22.598c-1.305-2.816-2.543-3.98-5.426-4.05v-1.235h13.805v1.235c-4.192.07-4.668 1.304-3.297 4.187l7.758 16.762z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M472.293 694.965c0 8.031 6.523 14.215 15.039 14.215 8.176 0 14.563-6.25 14.563-14.356 0-8.172-6.387-14.422-14.766-14.422-7.145 0-14.836 5.082-14.836 14.563m5.148-2.34c0-5.902 4.192-10.574 8.723-10.574 5.77 0 10.578 6.664 10.578 14.492 0 6.867-4.601 10.988-8.652 10.988-5.906 0-10.649-6.593-10.649-14.906",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M521.809 684.18h-7.418v18.816c0 3.16 1.238 4.055 5.082 4.055h2.613v1.304h-16.965v-1.304c3.984 0 4.668-.895 4.668-4.738V684.18h-5.082v-1.168c1.922-.41 3.57-1.032 5.082-1.852 0-5.703 1.238-10.027 5.289-14.082 3.363-3.363 6.594-4.875 9.75-4.875 3.848 0 7.074 2.199 7.074 3.227 0 .55-1.3 3.297-1.851 3.297-.961 0-3.504-3.364-8.035-3.364-4.946 0-7.625 3.914-7.625 10.574v5.223h6.937z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bf2f38",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf2f38",
      fillOpacity: 1
    },
    d: "M53.941 674.707c-.57-3.047-.285-9.066 2.692-15.016-10.98 8.286-11.121 15.016-11.121 15.016s2.125-1.629 8.43 0m-5.101-18.133s-13.317 1.914-17.14 2.27c-2.637 1.554-5.665 5.914-5.665 5.914s-3.117.457-9.351 1.59c-4.332 2.828-6.942 9.422-1.559 14.804-1.7-.355-1.7-.355-4.176-.781-5.312 3.402-2.836 9.707 8.215 7.512-3.117-.11-4.676-1.629-4.64-3.613-.07-2.161 4.144-4.852 9.277-3.473-4.887-9.242.531-12.891.531-12.891s-2.867 7.633 3.402 13.883c.567-.922 2.442-3.504 7.72-3.613 5.257-.106 8.562 2.48 8.64 5.457.07 2.621-3.258 5.383-7.578 5.383l-.07-6.262s-1.407.504-1.805 1.058c.004.29-.04 5.274-.04 5.274-1.699 0-5.167-.707-7.007-3.649-1.418-.14-9.317-1.312-9.317-1.312l.426 2.09s2.762.461 3.293 3.222c.645 3.344 2.55 6.411 4.25 7.653 3.293-.391 8.746-4.535 18.77-4.391-9.207 1.274-18.555 11.117-32.016 7.364 21.39 7.296 23.586-8.922 50.36-3.825-4.18-2.55-10.41-3.328-10.41-3.328s3.327-3.613 3.468-9.137c.426-.027.992-.07 2.055-.175.355-1.774.601-3.571.601-3.571s-5.843-.007-10.746-.007c-11.937-12.079.512-23.446.512-23.446m-29.887-.211c3.363.176 7.453-1.914 7.719-2.09 0 0-1.418 3.579 1.77 3.364 3.46-.231 7.44-2.004 8.003-2.266v-4.605c-.308.226-3.68 2.609-7.507 3.472-1.399.313-.922-.922-.782-1.629.145-.707.239-1.289-2.265-.25-10.235 4.25-10.766 1.348-10.766.993-.422.496-.242 2.796 3.828 3.011M73.2 635.047v73.324c-29.5-11.617-41.789 10.906-73.199 0v-73.324h14.945v7.914h8.57v-7.914h8.43v7.914h8.496l.004-7.914h8.496v7.914h9.243v-7.914z",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bf2f38",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf2f38",
      fillOpacity: 1
    },
    d: "M101.352 734.781s-.348-.172.316-.73c.082-.067.211.086.598.09.519.007.793-.172 1.226-.696.653-.789-.711-1.093-1.152-.711-.485.414-.832.844-1.25 1.227 0 0-.699.621.262.82m25.253 37.043c-1.167.953-4.781 2.778-5.683 3.203-.902.426-1.195.684-1.859 2-.817 1.614-1.594 4.536-1.383 4.746 2.23-.351 3.824-2.23 3.824-2.23s.035-.461-.461-1.242c-.41-.645.391-1.344.887-.938.379.313.902.375 1.222.106.317-.266 7.278-4.692 7.594-5.203-1.414-1.399-2.496-2.817-2.496-2.817s-.477 1.418-1.645 2.375m-27.199-19.41c-2.976-1.203-3.64-2.008-4.195-2.25-.496-.207-2.543.66-2.887 1.543-.922 2.371-2.976 6.25-3.277 6.801-.16.293-.336.637-.3 1.027.034.387.151 1.91.116 2.266a2.6 2.6 0 0 0 .16 1.168c.141.355.325 1.875 1.106 3.398 1.734-1.734 1.988-4.293 1.875-3.789 0 .016.55-.933-.832-1.363-.39-.121-.332-1.145.09-1.274.515-.16.777-.3 1.027-1.218.246-.926 1.184-4.235 1.488-4.871.047-.098.133-.266.305-.344a3.4 3.4 0 0 1 .844-.254c.133-.02.383.121.457.199.473.477 2.926 2.469 2.926 2.469s1.097-.106 1.769-.391c-.422-.672-.601-2.301-.672-3.117m-3-13.988s-1.039 1.277.133 1.594c.027.371.172 1.105.317 1.488.195.512.53.347.906-.082.37-.422.969-1.231 1.406-1.696.398-.425 1.785-.273 1.223.583-.371.566-.664.718-1.145.824-.375.082-.488-.242-.902.32-.434.586-.895.996-.133.996.398 0 1.156.371 1.66.289.477-.074.527-.383.578-.808.055-.446-.031-.7.465-.973.637-.356 1.574-1.207 1.859-1.508.325-.344.743-.265 1.168-.265.422 0 2.477.25 3.7-1.583.863-1.292.957-3.054.636-4.648.586.582 1.371 2.422.957 4.141-.738 3.066-2.246 3.238-3.773 3.558-.637.903-2.266 3.223-3.133 7.442-.371.246-3.453 3.218-.875 8.101-.664.215-2.621 1.055-3.781 1.317-.778.175-1.43.218-1.746.593-.352.422-1.168 1.805-.742 2.496.3.489 2.23 4.805 2.39 6.137.16 1.324.64 1.641 1.117 2.071.532.476.875.453 1.618 1.011.754.563 1.379 1.578 2.074 2.121.742.586 1.574.852 2.16.797-.145-2.16-.605-4.285-1.277-4.992-.7-.734-1.575.316-1.786.371-.214.055-.511-.152-.64-.742-.133-.613.426-1.117-.106-1.914a48 48 0 0 1-2.043-3.375c-.691-1.352.48-1.711.77-1.645.691.16 4.832.719 5.469.77.636.055.992.16 1.277-.16.875-.981 1.379-1.7 1.887-2.707.926.691.289 2.019.023 3.593.266.231 6.27 3.258 14.524 1.063 3.445-.914 3.05-.191 3.379.441 2 3.879 3.418 5.379 5.793 7.282.707.562 1.203 1.484 1.519 2.015.32.531.398 1.477.145 2.09-.321.762-2.164 4.066-2.481 4.531-.601.887-1.387 1.629-2.055 1.985-2.089 1.117-2.609 2.117-2.839 2.898h5.363s.125-.281.062-.949c-.089-.938.762-1.098 1.028-1.152.265-.051.742.16 1.168-.848.797-1.899 3.914-7.192 4.179-7.668.266-.481 1.239-1.758.282-2.32-1.805-1.063-2.868-2.809-3.223-4.766-.141-.777-.055-2.059 1.699-4.246 3.754-4.676.957-14.309-7.398-14.133-4.742.102-7.379-.301-10.465-.918-1.129-.226-1.324-.836-1.082-1.523.25-.707.488-2.118.496-2.692-.813-.746-2.055-1.203-2.656-1.418-.649-.226-.973-.746-.317-.797.653-.05 3.133.215 3.133.215s.09-1.328-.266-3.277a14.3 14.3 0 0 0-3.824-1.027c-.375-.047-.703-.465.246-.602 1.243-.176 2.375.02 3.258-.035.055-.106-.422-2.586-1.301-3.586-.609-.184-.933-.27-3.054-.524-.742-.085-.778-.3-.282-.46.575-.184 1.532-.372 2.727-.293-.461-.633-3.543-6.254-9.934-4.567.715.879 1.063 1.285 1.274 1.887.191.539-.379.711-.902.16-2.02-2.125-3.083-2.074-4.383-2.312.851.824 1.222 1.648 1.515 2.468-1.461 1.039-3.535 3.508-3.828 3.989-.555.906.215 1.398.215 1.398zm41.301-14.235c-6.535 2.286-5.57 9.329-3.809 12.039 2.305 3.543 4.25 3.614 5.719 7.774 1.149 3.246-.902 4.941-2.922 5.684 3.453 2.128 7.016-.071 8.289-2.196 2.348-3.129-.312-7.191 2.196-9.312.672-.567 1.804-.957 3.328-1.028-1.524-2.16-5.098-1.914-6.531.106-1.012-2.336-3.844-4.379-2.817-8.004.672-2.371 4.426-3.258 5.844-1.309.773 1.067.883 3.153-1.383 4.215 1.418-.105 4.109-2.551 2.266-5.879-1.293-2.34-3.469-2.515-5.239-2.515-3.222 0-8.57 3.683-5.152 11.632-1.969-1.75-5.152-7.859.211-11.207m16.301-8.277v73.414c-40.582 9.879-41.754-11.687-73.203 0 .004.953-.012-73.422 0-73.414 28.898-12.113 40.16 10.836 73.203 0",
    transform: "translate(.996 -630.672)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bf2f38",
      fillRule: "nonzero",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf2f38",
      fillOpacity: 1
    },
    d: "M26.629 757.797s-1.285.836.324 4.367c1.61 3.524 3.606 6.809.129 10.684 1.973.023 6.273-2.575 1.672-10.317-1.059-1.785-2.203-3.019-2.125-4.734m-4.352 1.66c1.063-.07 1.196-1.375 1.004-2.059-.226-.808-1.574-.91-1.902.122-.32 1.019-.04 2.007-.04 2.007.267.985 1.372 1.262 1.47 1.164-.618-.55-.45-.867-.532-1.234m1.02 4.688c-.254 3.117-2.043 3.578-2.043 3.578-3.121-1.434-4.793 2.492-2.176 3.648 3.32 1.469 5.348-2.82 5.547-3.613.559-2.25.613-3.84.36-7.488-.212-3.114.554-3.582 1.066-3.668.515-.086 1.582-.129 2.644 3.113 1.067 3.242 3.367 3.711 3.367 3.711s-3.331-5.422 1.301-10.426c2.157-2.324 6.547-3.648 5.735-6.906 0 0-.68 1.168-2 1.511-1.32.34-3.883.723-3.883.723s6.144-2.898 7.25-6.226c0 0 1.922 3.199-.637 7.89 0 0 2.434-.871 5.059.313 6.683 2.961 5.972 12.48-2.485 14.75-12.035 3.23-7.664 12.539-.773 13.109-.738-.469-.906-3.273.305-4.941.601-.539 1.683-1.625 2.367.66 1.21 4.031 4.742 4.359 6.383 3.855-.43-.363-1.235-1.59-1.137-2.297.203-1.41 1.965.055 2.605.239 4.743 1.343 7.262.168 7.532-.539-1.059-.219-.875-.102-1.547-.27-.625-.156-1.844-1.023.437-1.547 4.188-.957 6.492-5.277 3.735-8.605-2.633-3.18-5.95-2.692-7.028-2.254 4.54.976 4.766 4.629 2.453 6.488-2.015 1.516-7.027 2.117-8.742-1.242-1.082.781-1.46 2.035-1.277 3.598-.453-.172-2.356-2.875.469-5.11 13.097-8.445 10.984-22.633-.098-28.472l-.14-.059c-10.055-5.777-18.852-.504-18.852-.504 6.218-6.226 16.96-2.523 18.508-1.75 0 0-1.239-1.074-1.895-2.062-.852-1.278-.82-2.5-.82-2.5-4.266 2.382-5.364-1.274-5.364-1.274s-3.695 3.328-6.093.621c-2.094-2.371 1.3-5.586 1.3-5.586-21.636 7.102-17.535 19.321-17.535 19.321s-3.133 2.875-3.836 9.812c-.796 7.875 3.13 13.477 8.032 11.938 1.125-.352 1.68-.887 1.898-1.477zm49.906-48.231c.012-.008-.004 74.367 0 73.414-31.45-11.687-32.617 9.879-73.203 0v-73.414c33.04 10.836 44.305-12.113 73.203 0",
    transform: "translate(.996 -630.672)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUobLogo);
export default __webpack_public_path__ + "static/media/uob_logo.da0867001908fcc05d4dcc68f1a9b203.svg";
export { ForwardRef as ReactComponent };